import { render } from "./mainPage.vue?vue&type=template&id=53ab076a"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"

import "./mainPage.vue?vue&type=style&index=0&id=53ab076a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__